

































import { Component, Vue, Prop } from 'vue-property-decorator'
import {FraudCase} from "@/model/fraud-case";
import {fraudCaseService} from "@/services/fraud-case";

@Component
export default class CreateFraudCaseDialog extends Vue {

  @Prop()
  dialog!: boolean

  fraudCase: FraudCase = new FraudCase()

  doCancel() {
    this.$emit('closeDialog',true)
  }

  doCreate() {
    fraudCaseService.createFraudCase(
      this.fraudCase.hasChargebacks,
      this.fraudCase.hasStolenCards,
      this.fraudCase.blacklisted,
      this.fraudCase.blacklistTransactionId,
      this.fraudCase.blacklistComment)
    this.fraudCase = new FraudCase()
    this.$emit('closeDialog',true)
  }
}
